/**
 * Ashore API
 * All Endpoints to control your ashore account
 *
 * The version of the OpenAPI document: V1
 * Contact: info@ashoreapp.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The FeedbackRequest model module.
 * @module model/FeedbackRequest
 * @version V1
 */
class FeedbackRequest {
    /**
     * Constructs a new <code>FeedbackRequest</code>.
     * @alias module:model/FeedbackRequest
     */
    constructor() { 
        
        FeedbackRequest.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>FeedbackRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/FeedbackRequest} obj Optional instance to populate.
     * @return {module:model/FeedbackRequest} The populated <code>FeedbackRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new FeedbackRequest();

            if (data.hasOwnProperty('slackChannel')) {
                obj['slackChannel'] = ApiClient.convertToType(data['slackChannel'], 'String');
            }
            if (data.hasOwnProperty('subject')) {
                obj['subject'] = ApiClient.convertToType(data['subject'], 'String');
            }
            if (data.hasOwnProperty('text')) {
                obj['text'] = ApiClient.convertToType(data['text'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>FeedbackRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>FeedbackRequest</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['slackChannel'] && !(typeof data['slackChannel'] === 'string' || data['slackChannel'] instanceof String)) {
            throw new Error("Expected the field `slackChannel` to be a primitive type in the JSON string but got " + data['slackChannel']);
        }
        // ensure the json data is a string
        if (data['subject'] && !(typeof data['subject'] === 'string' || data['subject'] instanceof String)) {
            throw new Error("Expected the field `subject` to be a primitive type in the JSON string but got " + data['subject']);
        }
        // ensure the json data is a string
        if (data['text'] && !(typeof data['text'] === 'string' || data['text'] instanceof String)) {
            throw new Error("Expected the field `text` to be a primitive type in the JSON string but got " + data['text']);
        }

        return true;
    }


}



/**
 * @member {String} slackChannel
 */
FeedbackRequest.prototype['slackChannel'] = undefined;

/**
 * @member {String} subject
 */
FeedbackRequest.prototype['subject'] = undefined;

/**
 * @member {String} text
 */
FeedbackRequest.prototype['text'] = undefined;






export default FeedbackRequest;

